import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { RootState } from "..";
import { logger } from "../../../../utilities/logger";
import { IApproval } from "../../components/directoryComponents/myApprovals/ApprovalsModels";
import { ApprovalsService } from "../../components/directoryComponents/myApprovals/ApprovalsService";
import { typedAction } from "../helpers";
import { IApprovalState } from "../models/reduxModels";
import { RESET_APPROVALS, SET_IS_APPROVALS_LOADING, SET_APPROVALS, REMOVE_APPROVAL, SET_APPROVALSCOUNT, SET_LAST_APPROVAL_LOAD } from "./actionTypes";

const initialState: IApprovalState = { isApprovalsLoading: false, approvals: null, approvalCount: 0, lastApprovalLoad: "" };

const setIsApprovalsLoading = (isApprovalsLoading: boolean) => {
    return typedAction(SET_IS_APPROVALS_LOADING, isApprovalsLoading);
}

export const setApprovals = (approvals: IApproval[]) => {
    return typedAction(SET_APPROVALS, approvals);
}

export const setLastApprovalLoad = () => {
    return typedAction(SET_LAST_APPROVAL_LOAD);
}

export const setApprovalsCount = (approvalsCount: number) => {
    return typedAction(SET_APPROVALSCOUNT, approvalsCount);
}

export const removeApproval = (approval: IApproval) => {
    return typedAction(REMOVE_APPROVAL, approval);
}

export const resetApprovals = () => {
    return typedAction(RESET_APPROVALS);
}

export const getApprovals = (tenantId: string, shouldUpdateSilently: boolean = false, completedCallback: () => void = undefined): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch, getState) => {
    const state = getState();
    if (!state.approvals.isApprovalsLoading) {
        if (!shouldUpdateSilently) dispatch(setIsApprovalsLoading(true));
        let approvals: IApproval[];
        try {
            const approvalsService = new ApprovalsService(tenantId);
            approvals = await approvalsService.getMyApprovals();
        } catch (error) {
            logger(error, "approvals.ts (getApprovals)");
        }
        dispatch(setApprovals(approvals));
        if (!shouldUpdateSilently) dispatch(setApprovalsCount(approvals?.length ?? 0));
        if (completedCallback) completedCallback();
    }
};

type ApprovalsAction = ReturnType<typeof setIsApprovalsLoading | typeof setApprovals | typeof setLastApprovalLoad | typeof setApprovalsCount | typeof resetApprovals | typeof removeApproval>;

export function approvalsReducer(
    state = initialState,
    action: ApprovalsAction
): IApprovalState {
    switch (action.type) {
        case SET_IS_APPROVALS_LOADING:
            return { ...state, isApprovalsLoading: action.payload };
        case SET_APPROVALS:
            return { ...state, approvals: action.payload, isApprovalsLoading: false };
        case SET_LAST_APPROVAL_LOAD:
            return { ...state, lastApprovalLoad: new Date().toUTCString() };
        case SET_APPROVALSCOUNT:
            return { ...state, approvalCount: action.payload };
        case RESET_APPROVALS:
            return initialState;
        case REMOVE_APPROVAL:
            const newApprovals = [...state.approvals].filter(approval => approval.name != action.payload.name);
            return { ...state, approvals: newApprovals, approvalCount: state.approvalCount - 1 }
        default:
            return state;
    }
}